var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PosFrase"},[(_vm.tipoImagen=='Rojo')?_c('img',{attrs:{"src":require("../assets/ImagenesPagina/electro fitness rojo.png")}}):_c('img',{attrs:{"src":require("../assets/ImagenesPagina/electro fitness.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }